import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useAppDispatch, useAppSelector } from '@common/reducers/hooks/store.hook';
import { selectIsEditing, closeEditor } from '@common/reducers/RemindersUIReducer';
import ReminderEditor from './ReminderEditor';

export const ReminderEditorDialog: React.FC = () => {
    const dispatch = useAppDispatch();
    const isEditing = useAppSelector(selectIsEditing);

    const handleClose = () => {
        dispatch(closeEditor());
    };

    return (
        <Dialog open={isEditing} onOpenChange={handleClose}>
            <DialogContent 
                className="sm:max-w-[600px] border-none shadow-2xl bg-white dark:bg-slate-950 rounded-2xl overflow-hidden p-0 [&>button]:hidden"
            >
                <ReminderEditor />
            </DialogContent>
        </Dialog>
    );
};

export default ReminderEditorDialog;
